import { NavItemModel } from '../../common';

export const SRM_TICKET_OVERVIEW_ROUTE_PATH: string = 'tickets';
export const SRM_TICKET_CREATE_ROUTE_PATH: string = 'tickets/create';
export const SRM_TICKET_DETAILS_ROUTE_PATH: string = 'tickets/:ticketIdentifier';

export const DOCUMENTS_ROUTE_PATH: string = 'documents';
export const DOCUMENTS_CATEGORY_QUERY_PARAM: string = 'category';

export const LMIV_ROUTE_PATH: string = 'lmiv';
export const LMIV_SEARCH_QUERY_PARAM: string = 'q';

export const srmNavItem: NavItemModel = {
  name: SRM_TICKET_OVERVIEW_ROUTE_PATH,
  url: `/${SRM_TICKET_OVERVIEW_ROUTE_PATH}`,
  label: 'Anfragen & Reklamationen',
  icon: {
    name: 'comments-question-check',
    family: 'light',
  },
};

export const serviceNavigation: NavItemModel[] = [
  srmNavItem,
];
